export default "__VITE_ASSET__51ad61b7__"